export default () => {
    return (map, nodes) => {
        const {canDesignUv, designUv} = map.commands
        const ns = canDesignUv(nodes)

        if (0 === ns.length) {
            return []
        }

        return [
            {
                label: '编辑',
                onClick: () => designUv(ns),
            },
        ]
    }
}
